import "core-js/modules/es.array.filter";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createBairunUserGroup, deleteBairunUserGroup, updateBairunUserGroup, getBairunUserGroupList } from '@/api/bairun/userGroup'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import { formatTimeToStr } from '@/utils/date';
export default {
  name: 'UserGroup',
  components: {},
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getBairunUserGroupList,
      drawer: false,
      type: 'add',
      dialogTitle: '新增用户群',
      addDialogVisible: false,
      updateDialogVisible: false,
      formData: {
        ID: '',
        groupName: '',
        parentId: -1,
        parentGroupName: '',
        remark: ''
      },
      rules: {
        groupName: [{
          required: true,
          message: '请输入用户群名',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.pageSize = 9999999;
              _context.next = 3;
              return _this.getTableData();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 删除用户群
    deleteUserGroup: function deleteUserGroup(row) {
      var _this2 = this;

      this.$confirm('此操作将永久删除该用户群, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return deleteBairunUserGroup({
                  ID: row.ID
                });

              case 2:
                res = _context2.sent;

                if (res.code === 0) {
                  _this2.$message({
                    type: 'success',
                    message: '删除成功!'
                  });

                  if (_this2.tableData.length === 1 && _this2.page > 1) {
                    _this2.page--;
                  }

                  _this2.getTableData();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 关闭窗口
    closeDialog: function closeDialog() {
      this.addDialogVisible = false;
      this.updateDialogVisible = false;
      this.formData = {
        ID: '',
        groupName: '',
        parentId: -1,
        parentGroupName: ''
      };
    },
    // 确定弹窗
    enterDialog: function enterDialog() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this3.formData.ID === 0)) {
                  _context4.next = 3;
                  break;
                }

                _this3.$message({
                  type: 'error',
                  message: '用户群id不能为0'
                });

                return _context4.abrupt("return", false);

              case 3:
                _this3.$refs.formData.validate( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
                    var res, _res;

                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!valid) {
                              _context3.next = 15;
                              break;
                            }

                            _context3.t0 = _this3.type;
                            _context3.next = _context3.t0 === 'add' ? 4 : _context3.t0 === 'update' ? 9 : 14;
                            break;

                          case 4:
                            _context3.next = 6;
                            return createBairunUserGroup(_this3.formData);

                          case 6:
                            res = _context3.sent;

                            if (res.code === 0) {
                              _this3.$message({
                                type: 'success',
                                message: '添加成功!'
                              });

                              _this3.getTableData();

                              _this3.closeDialog();
                            }

                            return _context3.abrupt("break", 14);

                          case 9:
                            _context3.next = 11;
                            return updateBairunUserGroup(_this3.formData);

                          case 11:
                            _res = _context3.sent;

                            if (_res.code === 0) {
                              _this3.$message({
                                type: 'success',
                                message: '修改成功!'
                              });

                              _this3.getTableData();

                              _this3.closeDialog();
                            }

                            return _context3.abrupt("break", 14);

                          case 14:
                            _this3.addDialogVisible = false;

                          case 15:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 增加用户群
    addUserGroup: function addUserGroup(row) {
      this.dialogTitle = '新增用户群';
      this.type = 'add';
      this.addDialogVisible = true;

      if (row) {
        this.formData.parentId = row.ID;
        this.formData.parentGroupName = row.groupName;
      } else {
        this.formData.parentId = -1;
        this.formData.parentGroupName = '根用户群';
      }
    },
    // 编辑用户群
    updateUserGroup: function updateUserGroup(row) {
      this.dialogTitle = '编辑用户群';
      this.type = 'update';
      this.updateDialogVisible = true;
      this.formData.ID = row.ID;
      this.formData.groupName = row.groupName;

      if (row && row.parentId > 0) {
        this.formData.parentId = row.parentId;
        this.formData.parentGroupName = this.getParentName(row.parentId);
      } else {
        this.formData.parentId = -1;
        this.formData.parentGroupName = '根用户群';
      }
    },
    getParentName: function getParentName(parentId) {
      var parent = this.tableData.filter(function (item) {
        return item.ID === parentId;
      });
      return parent.groupName;
    }
  }
};